import { Maybe, User } from '@acre/graphql'

export const getUserNameByUserId = (users?: Maybe<User[]>, userId?: Maybe<string>) => {
  const user = users?.find(({ id }) => id === userId)
  const firstName = user?.first_name || ''
  const lastName = user?.last_name || ''
  return `${firstName} ${lastName}`
}
